import React, { useState } from 'react';
import axios from 'axios';
import { API_PATH } from './../Constant/constants'; // Example: 'http://3.110.167.23:8080/api/v1'
import useAuth from '../config/useAuth'; // Adjust path if needed

const DoctorSchedule = () => {
  const { user, token } = useAuth(); // ✅ token required for Authorization
  const selectedDoctorId = user?.id || '';

  const [scheduleDate, setScheduleDate] = useState('');
  const [startTime, setStartTime] = useState('');
  const [endTime, setEndTime] = useState('');
  const [slotInterval, setSlotInterval] = useState('');
  const [unavailableSlots, setUnavailableSlots] = useState([{ startTime: '', endTime: '' }]);
  const [generatedSlots, setGeneratedSlots] = useState([]);

  const handleUnavailableChange = (index, field, value) => {
    const updated = [...unavailableSlots];
    updated[index][field] = value;
    setUnavailableSlots(updated);
  };

  const addUnavailableRow = () => {
    setUnavailableSlots([...unavailableSlots, { startTime: '', endTime: '' }]);
  };

  const deleteUnavailableRow = (index) => {
    setUnavailableSlots(unavailableSlots.filter((_, i) => i !== index));
  };

  const generateSchedule = async () => {
    if (!selectedDoctorId || !token) {
      alert('Missing doctor or token. Please re-login.');
      return;
    }

    const payload = {
      doctorId: parseInt(selectedDoctorId, 10),
      scheduleDate,
      startTime,
      endTime,
      slotInterval: parseInt(slotInterval, 10),
      unavailableSlots,
    };

    try {
      const response = await axios.post(
        `${API_PATH}/doctors/${selectedDoctorId}/schedule/create`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      alert('Schedule created successfully.');
      setGeneratedSlots(response.data.appointmentSlots || []);
    } catch (error) {
      console.error('Error generating schedule:', error);
      if (error.response?.status === 403) {
        alert('Access denied (403). Please check your role or token.');
      } else {
        alert('Failed to generate schedule.');
      }
    }
  };

  return (
    <div>
      <div className="row">
        <div className="col">
          <label>Schedule Date:</label>
          <input
            type="date"
            className="form-control"
            value={scheduleDate}
            onChange={(e) => setScheduleDate(e.target.value)}
          />
        </div>
        <div className="col">
          <label>Start Time:</label>
          <input
            type="time"
            className="form-control"
            value={startTime}
            onChange={(e) => setStartTime(e.target.value)}
          />
        </div>
        <div className="col">
          <label>End Time:</label>
          <input
            type="time"
            className="form-control"
            value={endTime}
            onChange={(e) => setEndTime(e.target.value)}
          />
        </div>
        <div className="col">
          <label>Slot Interval (in minutes):</label>
          <input
            type="number"
            className="form-control"
            value={slotInterval}
            onChange={(e) => setSlotInterval(e.target.value)}
          />
        </div>
      </div>

      <div className="mb-3">
        <h5>Unavailable Slots</h5>
        {unavailableSlots.map((slot, index) => (
          <div className="row mb-2" key={index}>
            <div className="col-md-4">
              <input
                type="time"
                className="form-control"
                value={slot.startTime}
                onChange={(e) =>
                  handleUnavailableChange(index, 'startTime', e.target.value)
                }
              />
            </div>
            <div className="col-md-4">
              <input
                type="time"
                className="form-control"
                value={slot.endTime}
                onChange={(e) =>
                  handleUnavailableChange(index, 'endTime', e.target.value)
                }
              />
            </div>
            <div className="col-md-4">
              <button
                className="btn btn-danger"
                onClick={() => deleteUnavailableRow(index)}
              >
                Delete
              </button>
            </div>
          </div>
        ))}
        <button className="btn btn-secondary" onClick={addUnavailableRow}>
          Add More Rows
        </button>
      </div>

      <button className="btn btn-primary mb-4" onClick={generateSchedule}>
        Generate Schedule
      </button>

      <div>
        <h5>Generated Slots</h5>
        {generatedSlots.length > 0 ? (
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>Slot ID</th>
                <th>Start Time</th>
                <th>End Time</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {generatedSlots.map((slot, idx) => (
                <tr key={idx}>
                  <td>{slot.slotId}</td>
                  <td>{slot.startTime}</td>
                  <td>{slot.endTime}</td>
                  <td>{slot.status}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p>No slots generated yet.</p>
        )}
      </div>
    </div>
  );
};

export default DoctorSchedule;
